
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/testiomonials",
      function () {
        return require("private-next-pages/testiomonials/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/testiomonials"])
      });
    }
  